import BaseController from "../../controller/BaseController";

/**
 * @namespace com.reply.leaviosa.controller
 */
export default class PersonalDetailsController extends BaseController {

    public async onInit(): Promise<void> {
        
    }

}
